import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { usuario, cargando } = useAuth();

  if (cargando) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        fontSize: '20px',
        color: '#3d3c44'
      }}>
        Cargando...
      </div>
    );
  }

  return usuario ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;

